import CommonUiModel from "../common/commonUiModel";
import coreConfig from "../common/coreConfig";

const { isBasicAuth } = coreConfig;
const fieldLabelValue = isBasicAuth ? true : null;
const filterOptions = ({ options, stateData }) => {
    const { userDetails = {} } = stateData.getUserData;
    const equipmentList = userDetails.equipmentsList || [];
    for (let i = options.length - 1; i >= 0; i--) {
        if (!equipmentList.includes(options[i].value)) {
            options.splice(i, 1);
        }
    }
};

const columns = [
    { field: 'Username', label: 'Username', required: true, min: 1, max: 30, autoComplete: "new-password" },
    { field: 'FirstName', label: 'First Name', required: true, min: 1, max: 30 },
    { field: 'LastName', label: 'Last Name', required: true, min: 1, max: 30 },
    { field: 'EmailAddress', label: 'Email', type: 'email', required: true, width: 150, hide: true, autoComplete: "new-password" },
    { field: 'RoleId', label: 'User Role', width: 150, required: true, type: 'select', lookup: 'SecurityRole', selectField: "RoleId", dataIndex: "RoleName" },
    { field: 'IsActive', label: 'Active', width: 80, type: 'boolean', defaultValue: true },
    { field: 'LastLogin', gridLabel: 'Last Login', width: 200, type: 'dateTime', label: null },
    { field: "UserEquipments", label: "Equipments", lookup: 'Equipment', type: "autocomplete", hide: true, gridLabel: null, filterable: false, sortable: false, required: false, filter: filterOptions }
];

// Conditionally add Password column if fieldLabelValue is true
if (fieldLabelValue) {
    columns.push({
        field: 'PasswordHash',
        label: 'Password',
        hide: true,
        required: true,
        width: 250,
        type: 'password',
        gridLabel: null,
        autoComplete: "new-password"
    });

    columns.push({
        field: 'ConfirmPassword',
        label: 'Confirm Password',
        required: fieldLabelValue,
        hide: true,
        width: 250,
        type: 'password',
        validate: "compare:PasswordHash",
        gridLabel: null,
        autoComplete: "new-password"
    });
}

const UserModel = new CommonUiModel({
    title: "Users",
    idProperty: "UserId",
    linkColumn: "Username",
    initialValues: { IsActive: true },
    permissions: { delete: false },
    overrideFileName: "Users",
    tableName: "Security_User",
    columns: columns
});

export default UserModel;